import { Outlet } from 'react-router-dom';
import { styled } from '@material-ui/core/styles';
import { Navbar } from './navbar';
import { Sidebar } from './sidebar';
import { Footer } from './footer';

const DashboardLayoutRoot = styled('div')(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    height: '100%',
    width: '100%'
  })
);

export const Layout = () => (
  <DashboardLayoutRoot>
    <Navbar />    
    <Outlet />
    <Footer />
  </DashboardLayoutRoot>
);
